module.exports = __webpack_public_path__ + "img/banner-background-default.e98f4142.png";